<template>
  <div>
    <v-container>
      <div class="row">
        <div class="col-lg-4">
          <div class="position-relative">
            <div class="example-3d">
              <swiper class="swiper" :options="swiperOption">
                <swiper-slide v-for="item in items" :key="item.id">
                  <v-img
                    :src="item.src"
                    :style="{
                      Width: '700px',
                      Height: '700px',
                    }"
                  />
                </swiper-slide>
                <div class="swiper-pagination" slot="pagination"></div>
              </swiper>
            </div>
          </div>
        </div>
        <div class="col-lg-8">
          <h1 class="ma-5 title-small mb-2">{{ $t("welcome") }}</h1>
          <h3 class="ma-5 title-big">E-visa Cameroun</h3>
          <p class="ma-5" style="text-align: justify">
            {{ $t("home_text") }}
          </p>
          <v-btn
            v-if="!authenticated"
            href="/login"
            color="blue-grey"
            class="ma-2 pa-5 white--text"
            style="width: 155px; height: 40px"
          >
            {{ $t("sign_in") }}
            <!-- <i style="margin:4px;font-size:16px;" class="fas fa-sign-in-alt"></i> -->
          </v-btn>
          <v-btn
            v-if="!authenticated"
            href="/register"
            class="ma-2 pa-5 white--text"
            outlined
            color="blue-grey"
            style="width: 155px; height: 40px"
          >
            {{ $t("sign_up") }}
            <!-- <i style="margin:4px;font-size:16px;" class="fas fa-user-plus"></i> -->
          </v-btn>
        </div>
      </div>
    </v-container>

    <section class="w3l-counter-6">
      <div class="container">
        <h4 class="text-center m-3">{{ $t("guide_title") }}</h4>
        <section class="row col-md-12 mx-auto">
          <div class="main-timeline2">
            <div class="timeline">
              <span
                class="icon fa fa-user text-dark boder border-success"
              ></span>
              <a class="timeline-content">
                <h3 class="title">{{ $t("inscription") }}</h3>
                <p class="description">
                  {{ $t("inscription_p1") }}
                </p>
                <p class="description">
                  <strong>
                    <b>{{ $t("inscription_s") }}</b>
                  </strong>
                </p>

                <p class="description">
                  {{ $t("inscription_p3") }}
                </p>
              </a>
            </div>
            <div class="timeline">
              <span
                class="icon fa fa-wpforms text-dark boder border-success"
              ></span>
              <a class="timeline-content">
                <h3 class="title">{{ $t("request") }}</h3>
                <p class="description">
                  {{ $t("request_t") }}
                </p>
                <li class="mt-3">1-{{ $t("request_li1") }}</li>
                <li class="mt-3">2-{{ $t("request_li2") }}</li>
                <li class="mt-3">
                  <ol>
                    <strong>
                      <b>{{ $t("request_step1") }}</b>
                    </strong>
                    <li>-{{ $t("request_step1_d") }}</li>
                  </ol>
                  <ol>
                    <strong>
                      <b>{{ $t("request_step2") }}</b>
                    </strong>
                    <li>-{{ $t("request_step2_d") }}</li>
                  </ol>
                  <ol>
                    <strong>
                      <b>{{ $t("request_step3") }}</b>
                    </strong>
                    <li>-{{ $t("request_step3_d") }}</li>
                  </ol>
                  <ol>
                    <strong>
                      <b>{{ $t("request_step4") }}</b>
                    </strong>
                    <li>{{ $t("request_step4_d") }}</li>
                    <li>{{ $t("request_step4_d1") }}</li>
                  </ol>
                  <ol>
                    <strong>
                      <b>{{ $t("recap") }}</b>
                    </strong>
                    <li>{{ $t("recap_d") }}</li>
                  </ol>
                </li>
              </a>
            </div>
            <div class="timeline">
              <span
                class="icon fa fa-hourglass-half text-dark boder border-success"
              ></span>
              <div class="timeline-content">
                <h3 class="title">{{ $t("treatment") }}</h3>
                <p class="description">
                  {{ $t("treatment_t") }}
                </p>
                <li>
                  <ol>
                    <strong>
                      <b>{{ $t("treatment_l1") }}</b>
                    </strong>
                    <li>
                      {{ $t("treatment_d") }}
                    </li>
                  </ol>
                  <ol>
                    <strong>
                      <b>{{ $t("treatment_l2") }}</b>
                    </strong>
                    <li>
                      {{ $t("treatment_l2_d") }}
                    </li>
                  </ol>
                  <ol>
                    <strong>
                      <b>{{ $t("treatment_l3") }}</b>
                    </strong>
                    <li>
                      {{ $t("treatment_l3_d") }}
                    </li>
                  </ol>
                  <ol>
                    <strong>
                      <b>{{ $t("to_know") }}</b>
                    </strong>
                    <li>
                      <ol>
                        <strong>
                          <b>{{ $t("to_know_t") }}</b>
                        </strong>
                        <li>
                          <span class="badge bg-warning">PENDING</span>
                          {{ $t("complement") }}
                        </li>
                        <li>
                          <span class="badge bg-info">COMPLEMENT</span>
                          {{ $t("complement") }}
                        </li>
                        <li>
                          <span class="badge bg-danger">REJECT</span>
                          {{ $t("rejet") }}
                        </li>
                        <li>
                          <span class="badge bg-success">VALIDER</span>
                          {{ $t("valide") }}
                        </li>
                      </ol>
                    </li>
                  </ol>
                </li>
              </div>
            </div>
            <div class="timeline">
              <span
                class="icon fa fa-user text-dark boder border-success"
              ></span>
              <a class="timeline-content">
                <h3 class="title">{{ $t("get_psp_d_presentiel") }}</h3>
                <p class="description">
                  {{ $t("get_psp_d") }}
                </p>
              </a>
            </div>
          </div>
        </section>
      </div>
    </section>

    <section id="home" class="w3l-banner mb-2">
      <div class="container">
        <div class="row align-items-center">
          <div class="col-lg-6 col-md-6 col-sm-8 mt-lg-0 mt-4">
            <div>
              <p class="home-text">
                <i class="m-2 mdi mdi-account"></i>
                {{ $t("text1") }}
              </p>

              <p class="home-text">
                <i class="m-2 mdi mdi-pencil"></i>
                {{ $t("text2") }}
              </p>
              
              <p class="home-text">
                <i class="m-2 mdi mdi-currency-usd"></i>
                {{ $t("text3") }}
              </p>
            </div>
            <div class="mt-sm-5 mt-4">
              <a class="btn btn-outline-primary btn-style mr-2" href="/demand">
                {{ $t("ask_demand") }}
              </a>
            </div>
          </div>
          <div class="col-lg-6 col-md-6 col-sm-8 mt-lg-0 mt-4">
            <div class="text-lg-center">
              <img
                src="../../public/visa.png"
                alt="myphoto"
                class="img-fluid"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { Swiper, SwiperSlide } from "vue-awesome-swiper";
import "swiper/css/swiper.css";

import { validationMixin } from "vuelidate";
import {
  required,
  maxLength,
  email,
  minLength,
} from "vuelidate/lib/validators";
import img1 from "../../public/home-image.png";
import img2 from "../../public/home-image1.png";
import img3 from "../../public/home-image2.jpg";

export default {
  name: "Home",
  mixins: [validationMixin],
  validations: {
    name: { required, maxLength: maxLength(20) },
    email: { required, email },
    body: { required, minLength: minLength(20) },
  },
  components: {
    Swiper,
    SwiperSlide,
  },
  data() {
    return {
      name: "",
      email: "",
      body: "",
      swiperOption: {
        effect: "cube",
        grabCursor: true,
        autoplay: {
          delay: 1000,
          disableOnInteraction: true,
        },
        speed: 2000,
        cubeEffect: {
          shadow: true,
          slideShadows: true,
          shadowOffset: 70,
          shadowScale: 0.94,
        },
        pagination: {
          el: ".swiper-pagination",
        },
      },
      items: [
        {
          id: 1,
          src: img1,
        },
        {
          id: 2,
          src: img2,
        },
        {
          id: 3,
          src: img3,
        },
      ],
    };
  },
  created() {
    this.$store.dispatch("setCurrentRoute", this.$route.name);

    this.$root.$i18n.locale = this.langLocal;
    this.$store.dispatch("clear_registered");
  },
  computed: {
    ...mapGetters(["current_route", "authenticated", "langLocal", "isdark"]),
  },
};
</script>

<style lang="scss" scoped>
.main-timeline2 {
  padding-top: 50px;
  overflow: hidden;
  position: relative;
  font-family: "Muli";
}

.main-timeline2 li {
  color: black;
  font-size: 15px;
  letter-spacing: 1px;
  margin: 0 0 5 px;
}
.main-timeline2:before {
  content: "";
  width: 7px;
  height: 100%;
  background: #fff;
  margin: 0 auto;
  position: absolute;
  top: 80px;
  left: 0;
  right: 0;
}

.main-timeline2 .timeline {
  width: 50%;
  float: left;
  padding: 20px 60px;
  border-top: 7px solid #084772;
  border-right: 7px solid #084772;
  border-radius: 0 30px 0 0;
  position: relative;
  right: -3.5px;
}

.main-timeline2 .icon {
  display: block;
  width: 50px;
  height: 50px;
  line-height: 50px;
  border-radius: 50%;
  background: #fff;
  border: 1px solid #fff;
  text-align: center;
  font-size: 25px;
  color: #fff;
  box-shadow: 0 0 0 2px #fff;
  position: absolute;
  top: -30px;
  left: 0;
}

.main-timeline2 .timeline-content {
  display: block;
  padding: 30px 10px 10px;
  border-radius: 20px;
  background: #fff;
  color: #fff;
  position: relative;
}

.main-timeline2 .timeline-content:hover {
  text-decoration: none;
  color: #fff;
}

.main-timeline2 .timeline-content:after,
.main-timeline2 .timeline-content:before {
  content: "";
  display: block;
  width: 10px;
  height: 50px;
  border-radius: 10px;
  background: #fff;
  border: 1px solid #fff;
  position: absolute;
  top: -35px;
  left: 50px;
}

.main-timeline2 .timeline-content:after {
  left: auto;
  right: 50px;
}

.main-timeline2 .title {
  font-size: 24px;
  margin: 0;
}

.main-timeline2 .description {
  font-size: 15px;
  letter-spacing: 1px;
  margin: 0 0 5px;
}

.main-timeline2 .timeline:nth-child(2n) {
  border-right: none;
  border-left: 7px solid #084772;
  border-radius: 30px 0 0;
  right: auto;
  left: -3.5px;
}

.main-timeline2 .timeline:nth-child(2n) .icon {
  left: auto;
  right: 0;
  box-shadow: 0 0 0 2px #fff;
}

.main-timeline2 .timeline:nth-child(2) {
  margin-top: 130px;
}

.main-timeline2 .timeline:nth-child(odd) {
  margin: -130px 0 30px;
}

.main-timeline2 .timeline:nth-child(even) {
  margin-bottom: 80px;
}

.main-timeline2 .timeline:first-child,
.main-timeline2 .timeline:last-child:nth-child(even) {
  margin: 0 0 30px;
}

.main-timeline2 .timeline:nth-child(2n) .icon,
.main-timeline2 .timeline:nth-child(2n) .timeline-content,
.main-timeline2 .timeline:nth-child(2n) .timeline-content:after,
.main-timeline2 .timeline:nth-child(2n) .timeline-content:before {
  background: #fff;
}

.main-timeline2 .timeline:nth-child(3n) .icon,
.main-timeline2 .timeline:nth-child(3n) .timeline-content,
.main-timeline2 .timeline:nth-child(3n) .timeline-content:after,
.main-timeline2 .timeline:nth-child(3n) .timeline-content:before {
  background: #fff;
}

.main-timeline2 .timeline:nth-child(3n) .icon {
  box-shadow: 0 0 0 2px #fff;
}

.main-timeline2 .timeline:nth-child(4n) .icon,
.main-timeline2 .timeline:nth-child(4n) .timeline-content,
.main-timeline2 .timeline:nth-child(4n) .timeline-content:after,
.main-timeline2 .timeline:nth-child(4n) .timeline-content:before {
  background: #fff;
}

.main-timeline2 .timeline:nth-child(4n) .icon {
  box-shadow: 0 0 0 2px #fff;
}

@media only screen and (max-width: 767px) {
  .main-timeline2:before {
    left: 0;
    right: auto;
  }
  .main-timeline2 .timeline,
  .main-timeline2 .timeline:nth-child(even),
  .main-timeline2 .timeline:nth-child(odd) {
    width: 100%;
    float: none;
    padding: 20px 30px;
    margin: 0 0 30px;
    border-right: none;
    border-left: 7px solid #084772;
    border-radius: 30px 0 0;
    right: auto;
    left: 0;
  }
  .main-timeline2 .icon {
    left: auto;
    right: 0;
  }
}

@media only screen and (max-width: 480px) {
  .main-timeline2 .title {
    font-size: 18px;
  }
}

.title-big {
  color: rgb(63, 53, 99);
}
.v-container {
  margin-top: 70px;
}
.example-3d {
  position: relative;
  overflow: hidden;
  height: 360px;
  padding: 15px;
}

.swiper {
  width: 300px !important;
  height: 300px;
  position: absolute;
  left: 50%;
  top: 50%;
  margin-left: -150px;
  margin-top: -150px;

  .swiper-slide {
    display: flex;
    justify-content: center;
    align-items: center;
    text-align: center;
    font-weight: bold;
    background-position: center;
    background-size: cover;
    color: white;
  }
  #visa-img {
    border-radius: 100%;
  }
  .home-text {
    line-height: 45;
    text-align: justify;
    color: rgb(63, 53, 99);
  }
}
@media (max-width: 700px) {
  .v-container {
    margin-top: 80px;
  }
}
</style>
